import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgBoxIcon} from "~/assets/svg/box.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmBoxIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgBoxIcon id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
